import type { LucideIcon } from 'lucide-react';
import { BookOpen, FileText, Home, ListChecks, Sparkles, Users } from 'lucide-react';

export interface NavItem {
  id: string;
  label: string;
  path: string;
  icon: LucideIcon;
}

/**
 * The navigation model, in two tiers (design review P1.1):
 *
 * - PRIMARY surfaces live in the bottom tab bar on mobile and at the top of
 *   the desktop sidebar/drawer — the places you visit daily, one thumb tap
 *   away. "Chat" is the unified conversation page (capture + ask collapsed;
 *   the brand name stays in the wordmark; nav labels name the action).
 * - SECONDARY surfaces (the power-user document index, space administration)
 *   live in the drawer/sidebar only.
 */
export const PRIMARY_NAV: NavItem[] = [
  { id: 'home', label: 'Home', path: '/', icon: Home },
  { id: 'entries', label: 'Journal', path: '/entries', icon: BookOpen },
  { id: 'lists', label: 'Lists', path: '/lists', icon: ListChecks },
  { id: 'ask', label: 'Chat', path: '/alma', icon: Sparkles },
];

export const SECONDARY_NAV: NavItem[] = [
  { id: 'docs', label: 'Documents', path: '/docs', icon: FileText },
  { id: 'spaces', label: 'Spaces', path: '/spaces', icon: Users },
];

/** Whether a nav item is the active surface for the current pathname. */
export function isNavActive(item: NavItem, pathname: string): boolean {
  if (item.path === '/') return pathname === '/';
  if (item.path === '/docs') return pathname === '/docs' || pathname.startsWith('/docs/');
  if (item.path === '/alma') return pathname === '/alma' || pathname.startsWith('/alma/');
  return pathname === item.path;
}
